// src/pages/BrowseColors.jsx
import React from "react";
import { Link } from "react-router-dom";
import { COLORS } from "../data/colors";

export default function BrowseColors() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
            Browse Colors
          </h1>
          <p className="text-neutral-400 mt-3 max-w-2xl">
            Pick your finish, see it on a roll, then choose the size and shipping on the next page.
            All films are pro-grade wrap material we actually install in our shop.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {COLORS.map((color) => (
          <Link
            key={color.slug}
            to={`/colors/${color.slug}`}
            className="group rounded-2xl overflow-hidden border border-neutral-800 bg-neutral-950/80 hover:border-neutral-500 transition"
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={color.thumb}
                alt={color.name}
                className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80" />
              <div className="absolute bottom-3 left-4 right-4">
                <div className="text-[11px] uppercase tracking-wide text-neutral-300">
                  {color.brand} • {color.finish}
                </div>
                <div className="text-white text-lg font-semibold">{color.name}</div>
              </div>
            </div>

            <div className="px-4 py-3 flex items-center justify-between text-xs text-neutral-400">
              <span>{color.family}</span>
              <span>From ${color.basePrice}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
